import {DIVIPOLA} from "./Divipola";


export const obtenerCodigoDane = (pedido) => {

    let esto = DIVIPOLA.filter((e) => e.NOMBRE_DEPTO === pedido.departamento && e.Nombre === pedido.ciudad)

    if (esto.length > 0) {
        return esto[0].CODIGO_MUNICIPIO
    } else {
        return 0
    }
}